import { render, staticRenderFns } from "./talent1.vue?vue&type=template&id=ea762d5e&scoped=true"
import script from "./talent1.vue?vue&type=script&lang=js"
export * from "./talent1.vue?vue&type=script&lang=js"
import style0 from "./talent1.vue?vue&type=style&index=0&id=ea762d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea762d5e",
  null
  
)

export default component.exports